var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 46,
    viewBox: "0 0 52 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7031 24.5996L28.4753 27.8383C27.1664 29.1518 24.8634 29.1801 23.5262 27.8383L20.2982 24.5996L8.70508 36.2304C9.13662 36.43 9.61241 36.549 10.1182 36.549H41.8832C42.3891 36.549 42.8647 36.4301 43.2961 36.2305L31.7031 24.5996Z",
    fill: "#00020F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8831 9.45117H10.1181C9.61226 9.45117 9.13646 9.57025 8.70508 9.7698L21.0932 22.199C21.094 22.1998 21.095 22.2 21.0958 22.2008C21.0967 22.2017 21.0968 22.2028 21.0968 22.2028L25.1249 26.2442C25.5527 26.672 26.4486 26.672 26.8765 26.2442L30.9037 22.2035C30.9037 22.2035 30.9047 22.2017 30.9055 22.2008C30.9055 22.2008 30.9073 22.1998 30.9081 22.199L43.296 9.76973C42.8646 9.5701 42.3889 9.45117 41.8831 9.45117Z",
    fill: "#00020F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09097 11.3486C6.86771 11.8001 6.73071 12.3013 6.73071 12.8381V33.1617C6.73071 33.6985 6.86756 34.1997 7.09089 34.6512L18.7042 23.0003L7.09097 11.3486Z",
    fill: "#00020F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9097 11.3486L33.2966 23.0004L44.9097 34.6515C45.133 34.2 45.27 33.6988 45.27 33.1618V12.8383C45.27 12.3013 45.133 11.8001 44.9097 11.3486Z",
    fill: "#00020F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.5116f4a23e161f10069e883a8b0d8fc3.svg";
export { ForwardRef as ReactComponent };